import { all, fork } from 'redux-saga/effects';

import app from './app/sagas';
import player from './player/sagas';

export default function* rootSaga() {
  yield all([fork(app)]);
  yield all([fork(player)]);
};
